import { TextBox } from "./text-box";

export class PasswordBox extends TextBox {
    public type = "password";

    public getComponentName(): string {
        return "PasswordBoxComponent";
    }
}
